import { compose, prop } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getHasChanged = compose(prop('dataChanged'), getRoot);
export const getAdditionalData = compose(prop('additionalData'), getRoot);
export const getActiveKeys = compose(prop('activeKeys'), getRoot);
export const getInactiveKeys = compose(prop('inactiveKeys'), getRoot);

export const getActiveData = createSelector(getAdditionalData, getActiveKeys, (data, keys) =>
	keys.map((key) => data[key]),
);

export const getInactiveData = createSelector(getAdditionalData, getInactiveKeys, (data, keys) =>
	keys.map((key) => data[key]),
);
